// extracted by mini-css-extract-plugin
export default {"partnerManager":"PartnerManager_partnerManager__jqPpS"};